export default __webpack_public_path__ + "static/media/profile-pic.d4ebe9fb.png";